const DEFAULT_SUMMARY_LENGTH = 120;

export const summarizeTaskPrompt = (prompt: string, maxLength = DEFAULT_SUMMARY_LENGTH): string => {
  const normalized = (prompt || '').replace(/\s+/g, ' ').trim();
  if (!normalized) return 'Untitled task';
  if (normalized.length <= maxLength) return normalized;

  const truncated = normalized.slice(0, maxLength).trimEnd();
  const boundaries = ['. ', '? ', '! ', '; ', ', ', ' '];
  const cutoff = boundaries
    .map((token) => truncated.lastIndexOf(token))
    .reduce((best, current) => Math.max(best, current), -1);

  const shouldUseBoundary = cutoff >= Math.floor(maxLength * 0.6);
  const summary = (shouldUseBoundary ? truncated.slice(0, cutoff) : truncated).trimEnd();
  return `${summary}…`;
};
